<template lang="pug">
section.mhek__additional-news.module-layout(aria-labelledby="mhek-additional-news")
	h2#mhek-additional-news.sr-only További híreink
	.knowledge-base-container
		.knowledge-base-col.knowledge-base-col--small
			KnowledgeBaseTags(:select="select")
		.knowledge-base-col(v-show="!technicalError")
			KnowledgeBaseList(v-if="formState == FORM_STATES.FORM", :select="select")
			TechnicalError(v-if="formState == FORM_STATES.TECHNICAL_ERROR")
			NoResult(v-if="formState == FORM_STATES.NO_RESULT")
			.knowledge-base-spinner(v-if="formState == FORM_STATES.LOADING")
				VueSpinner
	VuePagination(v-model="currentPage", :total-rows="allNewsCount", :has-max-page="false", :page-size="pageSize", @input="gotoPage")
</template>
<script>
import KnowledgeBaseList from './knowledge-base-list/knowledge-base-list.vue';
import KnowledgeBaseTags from './knowledge-base-tags/knowledge-base-tags.vue';
import TechnicalError from '../../common/components/technical-error/technical-error.vue';
import NoResult from '../../common/components/no-result/no-result.vue';
import { mapState, mapActions } from 'vuex';
import VuePagination from '@ui-common/vue-pagination';
import VueSpinner from '@ui-common/vue-spinner';
const SEPARATOR = '/';
const ALL_THEME_TAG_URL = 'osszes';
const FORM_STATES = {
	FORM: 'FORM',
	LOADING: 'LOADING',
	TECHNICAL_ERROR: 'TECHNICAL_ERROR',
	NO_RESULT: 'NO_RESULT'
};

export default {
	props: {
		pageSize: {
			type: Number,
			default: 10
		},
		niceUrlFull: {
			type: String,
			required: true
		},
		niceUrl: {
			type: String,
			required: true
		}
	},
	components: {
		KnowledgeBaseList,
		KnowledgeBaseTags,
		TechnicalError,
		NoResult,
		VuePagination,
		VueSpinner
	},
	computed: {
		...mapState('knowledgeBaseModule', ['technicalError', 'loading', 'newsList', 'tags', 'allThemeTag', 'visibleHits', 'allNewsCount', 'selectedTag']),
		currentPage: {
			get() {
				return this.$store.state.knowledgeBaseModule.currentPage;
			},
			set(value) {
				this.$store.dispatch('knowledgeBaseModule/setCurrentPage', value);
			}
		},
		formState() {
			if (this.technicalError) {
				return FORM_STATES.TECHNICAL_ERROR;
			} else if (this.loading) {
				return FORM_STATES.LOADING;
			} else if (!this.visibleHits) {
				return FORM_STATES.NO_RESULT;
			}
			return FORM_STATES.FORM;
		},
		FORM_STATES: () => FORM_STATES
	},
	methods: {
		...mapActions('knowledgeBaseModule', ['getNews', 'getTags', 'selectTag', 'pushTag', 'setCurrentPage']),
		getParamsFromPath(path) {
			const splitted = path.split(SEPARATOR);
			const indexOfNews = splitted.indexOf(this.niceUrl);
			const tagUrl = splitted[indexOfNews + 1];
			const tag = tagUrl ? this.findTag(tagUrl) : {};
			return {
				tag: !tagUrl || tagUrl == ALL_THEME_TAG_URL ? null : tag.tag,
				url: !tagUrl || tagUrl == ALL_THEME_TAG_URL ? null : tag.url,
				pageNo: splitted[indexOfNews + 2] - 1 || '0',
				pageSize: this.pageSize
			};
		},
		findTag(tagUrl) {
			let resultTag = this.allThemeTag;
			if (this.tags && this.tags.length) {
				resultTag =
					this.tags.find((tag) => {
						return tag.url == tagUrl;
					}) || resultTag;
			}
			return resultTag;
		},
		gotoPage() {
			this.select(this.selectedTag);
		},
		select(tag, isNewTag = false) {
			if (isNewTag) {
				this.currentPage = 1;
			}
			this.selectTag(tag);
			const params = {
				tag: tag.url == ALL_THEME_TAG_URL ? null : tag.tag,
				pageNo: this.currentPage - 1,
				pageSize: this.pageSize
			};
			this.getNews(params).then(() => {
				const url = this.createUrl(tag);
				window.history.pushState({}, '', url);
				this.$scrollTo(this.$el);
			});
		},
		createUrl(tag) {
			return window.location.origin + this.niceUrlFull + SEPARATOR + tag.url + SEPARATOR + this.currentPage;
		}
	},
	mounted() {
		window.onpopstate = () => {
			const params = this.getParamsFromPath(window.location.pathname);
			const tag = this.findTag(params.tag);
			this.getNews(params);
			this.selectTag(tag);
		};
	},
	async created() {
		try {
			await this.getTags();
			this.pushTag(this.allThemeTag);
			const params = this.getParamsFromPath(window.location.pathname);
			const tag = this.findTag(params.url);
			this.getNews(params);
			this.selectTag(tag);
		} catch (error) {}
	}
};
</script>
<style lang="scss" scoped>
@import '@ui-common/sf-style-utils/lib/helpers/_queries.scss';

.knowledge-base-container {
	@include media('>=tablet') {
		display: flex;
	}
}

.knowledge-base-col {
	flex-grow: 1;
	order: 1;
}

.knowledge-base-col--small {
	@include media('>=tablet') {
		margin-left: 16px;
		max-width: 32%;
		min-width: 32%;
		order: 2;
	}

	@include media('>=tablet') {
		margin-left: 32px;
	}
}

.knowledge-base-spinner {
	align-items: center;
	display: flex;
	min-height: 600px;
	position: relative;
}
</style>
